module.exports = __webpack_public_path__ + "img/bell.17fd0324.svg";